import { Play } from "lucide-react";
import { Reveal } from "@/components/od/Reveal";

const COPY = {
  en: {
    eyebrow: "The 30-second film",
    title: "Watch what calm looks like.",
    body: "From the question that waits in an inbox to the answer that's simply there — thirty seconds, no actors, no jargon.",
  },
  fr: {
    eyebrow: "Le film de 30 secondes",
    title: "Voyez à quoi ressemble le calme.",
    body: "De la question qui attend dans une boîte courriel à la réponse qui est simplement là — trente secondes, sans jargon.",
  },
  es: {
    eyebrow: "El filme de 30 segundos",
    title: "Vea cómo se siente la calma.",
    body: "De la pregunta que espera en un buzón a la respuesta que simplemente está ahí — treinta segundos, sin jerga.",
  },
};

const VIDEO_SRC = {
  en: "/quiet-dashboard.mp4",
  fr: "/quiet-dashboard-fr.mp4",
  es: "/quiet-dashboard-es.mp4",
};

const POSTER_SRC = {
  en: "/quiet-dashboard-poster.jpg",
  fr: "/quiet-dashboard-fr-poster.jpg",
  es: "/quiet-dashboard-es-poster.jpg",
};

export default function FilmSection({ lang = "en" }) {
  const t = COPY[lang] || COPY.en;
  const src = VIDEO_SRC[lang] || VIDEO_SRC.en;
  const poster = POSTER_SRC[lang] || POSTER_SRC.en;
  const videoSchema = {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    name: t.title,
    description: t.body,
    thumbnailUrl: `https://oceandata.ca${poster}`,
    uploadDate: "2026-09-18",
    duration: "PT30S",
    contentUrl: `https://oceandata.ca${src}`,
    inLanguage: lang === "fr" ? "fr-CA" : lang === "es" ? "es" : "en-CA",
  };
  return (
    <section data-testid="film-section" className="py-16 lg:py-24 bg-white">
      <script type="application/ld+json" data-testid="film-video-schema" dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchema) }} />
      <div className="max-w-5xl mx-auto px-4 sm:px-8">
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-brand-teal font-semibold mb-5">
          {t.eyebrow}
        </p>
        <h2 className="font-display font-bold tracking-tight text-brand-navy text-3xl sm:text-4xl max-w-2xl mb-4">
          {t.title}
        </h2>
        <p className="max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed mb-10">
          {t.body}
        </p>
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-xl bg-brand-navy">
            <video
              data-testid="film-video"
              className="w-full aspect-video"
              src={src}
              poster={poster}
              controls
              muted
              playsInline
              preload="metadata"
            />
            <span className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-brand-navy/70 backdrop-blur px-4 py-1.5 text-[11px] font-mono uppercase tracking-[0.16em] text-brand-pale pointer-events-none">
              <Play size={11} /> 30s
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
